export const ORIGINAL_MESSAGE_MARKER = "-- Original Message --";

export function buildOriginalThread(existingMessage) {
  const original = String(existingMessage || "").trim();
  if (!original) return "";
  if (original.includes(ORIGINAL_MESSAGE_MARKER)) return original;
  return `${ORIGINAL_MESSAGE_MARKER}\n${original}`;
}

export function composeOutgoingMessage(response, originalThread) {
  const body = String(response || "").trim();
  const thread = String(originalThread || "").trim();
  if (!body) return "";
  if (!thread) return body;
  return `${thread}\n\nResponse: ${body}`;
}

export function normalizeReplySubject(subject) {
  const originalSubject = String(subject || "No Subject").trim() || "No Subject";
  return /^Re:\s*/i.test(originalSubject)
    ? originalSubject
    : `Re: ${originalSubject}`;
}
